import { Button, Grid, IconButton, TextField } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { removeUndefinedAndNull } from 'src/common/removeUndefinedAndNull';
import ModalsWrapper from 'src/components/Modals/ModalsWrapper';
import Toaster from 'src/Toaster/Toaster';
import SpecificRemoveFromGroup from './SpecificRemoveFromGroup';
import VisibilityIcon from '@mui/icons-material/Edit';
import UpdateDataApi from 'src/common/FetchData/UpdateDataApi';
import CommonMultipleSelectMembers from 'src/common/CommonMultipleSelectMembers';
const EditGroup = ({
  id,
  name,
  setRefresh,
}: {
  id: any;
  name: any;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { updateData, success, loading } = UpdateDataApi(
    `/api/admin/member-group/${id}`
  );
  useEffect(() => {
    if (success) {
      setRefresh(true);
      setOpen(false);
    }
  }, [success]);
  const [open, setOpen] = useState(false);
  const [removeMember, setRemoveMember] = useState<number[]>();
  const [inputData, setInputData] = useState<{
    add_member: number | number[] | string;
    remove_member: string | number[];
    name: string;
  }>({
    add_member: '',
    remove_member: '',
    name: '',
  });

  const onSubmit = async () => {
    const body = {
      name: inputData.name,
      remove_member: removeMember,
      add_member: inputData.add_member,
    };

    const removeData = removeUndefinedAndNull(body);
    if (Object.keys(removeData).length === 0) {
      Toaster().fire({
        icon: 'warning',
        title: 'please change any field',
      });
    } else {
      updateData(removeData);
    }
  };
  return (
    <>
      <Box sx={{ cursor: 'pointer' }} onClick={() => setOpen(true)}>
        <IconButton
          sx={{
            color: 'green',
          }}
          color='inherit'
          size='small'
        >
          <VisibilityIcon sx={{ fontSize: '20px' }} />
        </IconButton>
      </Box>
      <Grid container>
        <Grid item sm={12} md={12}>
          <ModalsWrapper
            setShowModal={setOpen}
            showModal={open}
            modalData={{ title: 'Update Group Members' }}
          >
            <Box sx={{ padding: 2 }}>
              <Grid container rowGap={3}>
                <Grid item xs={12}>
                  <Grid item xs={12} md={12} mt={2}>
                    <TextField
                      size='small'
                      id='outlined-basic'
                      placeholder='Enter Group Name'
                      label='Enter Group Name'
                      defaultValue={name}
                      required
                      onChange={(e) =>
                        setInputData({ ...inputData, name: e.target.value })
                      }
                      variant='outlined'
                      type='text'
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={12} lg={12} mt={2}>
                    <CommonMultipleSelectMembers
                      onChange={(e) =>
                        setInputData((value) => ({ ...value, add_member: e }))
                      }
                      label='Add More Members'
                    />
                  </Grid>
                  <Grid xs={12}>
                    <Box
                      sx={{
                        padding: '5px',
                        fontWeight: 'bold',
                        fontSize: '16px',
                      }}
                    >
                      Remove specific member from this group
                    </Box>
                    <SpecificRemoveFromGroup
                      id={id}
                      setRemoveMember={setRemoveMember}
                      existMember={inputData?.add_member as number[]}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {loading ? (
                <Button
                  fullWidth
                  variant='contained'
                  disableElevation
                  sx={{
                    mt: 3,
                    mb: 2,
                    py: 1,
                  }}
                  size='small'
                >
                  Loading ...
                </Button>
              ) : (
                <Button
                  onClick={onSubmit}
                  fullWidth
                  variant='contained'
                  disableElevation
                  sx={{
                    mt: 3,
                    mb: 2,
                    py: 1,
                  }}
                  size='small'
                >
                  Update Group
                </Button>
              )}
            </Box>
          </ModalsWrapper>
        </Grid>
      </Grid>
    </>
  );
};

export default EditGroup;
